import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
//import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/custom.scss";
import "./css/main.css"
import {AuthContextProvider} from "./store/auth-context";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <AuthContextProvider>
        <App />
    </AuthContextProvider>
);

